/**
 * flatpickr for pages with date fields: one pinned copy from npm (it used to
 * come from a CDN, unpinned). Loaded as a module, so it is defined before
 * DOMContentLoaded, when the pages initialise their pickers.
 */
import flatpickr from 'flatpickr';

window.flatpickr = flatpickr;
